import { colors } from 'styles/variables'

export const THEMES = {
  primary: colors.primaries.primary1,
  black: colors.black100,
}
